import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { ApprovalOperation } from 'ui-product-approvals-common';
import { MAX_APPROVAL_NOTE_LENGTH } from '../../constants/requestModal';
import { ApprovalModalMessageLabelHelpI18n, ApprovalModalMessageLabelI18n } from '../i18n/ApprovalModalMessageLabelI18n';
import { ApprovalDataErrorMessage } from '../sidebar/ApprovalDataErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const LazyApprovalNoteEditor = Loadable({
  loader: () => import( /* webpackChunkName: "ApprovalNoteEditor" */'./ApprovalNoteEditor').then(module => ({
    default: module.ApprovalNoteEditor
  })),
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingSpinner, {
    layout: "centered",
    size: "small"
  }),
  ErrorComponent: ApprovalDataErrorMessage
});
const getNotePlaceholder = (currentOperation, noteIsRequired) => {
  if (currentOperation === ApprovalOperation.REQUEST) {
    return unescapedText('productApprovals.approvalModalRequestNotePlaceholder');
  }
  if (noteIsRequired) {
    return unescapedText('productApprovals.approvalModalMessagePlaceholder');
  }
  return unescapedText('productApprovals.approvalModalMessagePlaceholderOptional');
};
export const ApprovalNoteField = ({
  approvalType,
  currentOperation,
  initialNote,
  isNoteTooLong,
  onChangeNote,
  onNoteOverLimit
}) => {
  const noteIsRequired = currentOperation === ApprovalOperation.CANCEL || currentOperation === ApprovalOperation.REJECT || currentOperation === ApprovalOperation.REQUEST_CHANGES;
  return /*#__PURE__*/_jsx(FormControl, {
    inlineSize: "100%",
    help: /*#__PURE__*/_jsx(ApprovalModalMessageLabelHelpI18n, {
      currentOperation: currentOperation,
      approvalType: approvalType
    }),
    label: /*#__PURE__*/_jsx(ApprovalModalMessageLabelI18n, {
      currentOperation: currentOperation,
      approvalType: approvalType
    }),
    required: noteIsRequired,
    validationMessage: isNoteTooLong && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalModalNoteError.exceedsMaxLength",
      options: {
        maxLength: MAX_APPROVAL_NOTE_LENGTH
      }
    }),
    error: isNoteTooLong,
    children: /*#__PURE__*/_jsx(LazyApprovalNoteEditor, {
      "data-test-id": `product-approvals-approval-note-${currentOperation}`,
      placeholder: getNotePlaceholder(currentOperation, noteIsRequired),
      onChangeNote: onChangeNote,
      initialHtml: initialNote,
      charLimit: MAX_APPROVAL_NOTE_LENGTH,
      onOverLimit: onNoteOverLimit
    })
  });
};